'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./CountIndicator.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CountIndicator = function CountIndicator(_ref) {
    var count = _ref.count,
        hide = _ref.hide,
        badge = _ref.badge;

    if (hide || !count) return null;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('CountIndicator', { badge: badge }) },
        count
    );
};

CountIndicator.propTypes = {
    count: _propTypes2.default.number,
    hide: _propTypes2.default.bool,
    badge: _propTypes2.default.bool
};

exports.default = CountIndicator;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/misc/CountIndicator.js
// module id = 440
// module chunks = 0